import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { Dimmer, Grid, Loader } from "semantic-ui-react";
import { useGetRecipeById } from "../../../api/recipeSimulator";
import PlusIcon from "../../../assets/commonIcon/PlusIcon";
import { CustomButton, TitleBar } from "../../../components";
import { extractUsedColors } from "../../../utils/recipeColor.utill";
import RecipeAddIngredientModal from "../recipeAddIngredient/RecipeAddIngredientModal";
import "./RecipeIngredientRegister.scss";

const RecipeIngredientRegister = () => {
  const { recipeId } = useParams();
  const [ingredientVisibleModal, setIngredientVisibleModal] = useState(false);
  const {
    data: recipeData,
    refetch: recipeDataRefetch,
    isLoading: isRecipeDataLoading
  } = useGetRecipeById(recipeId);

  const usedColors = useMemo(() => extractUsedColors(recipeData ?? null), [recipeData]);

  if (isRecipeDataLoading) {
    return (
      <Dimmer active>
        <Loader content="Loading" />
      </Dimmer>
    );
  }

  return (
    <>
      <TitleBar titleName={recipeData?.recipeName} />
      <Grid className="pt-0">
        <Grid.Column computer={16} className="productContentView">
          <Grid.Column computer={8} tablet={8} mobile={16}>
            <CustomButton
              theme="green"
              title="Add Ingredient Name"
              onClick={() => {
                setIngredientVisibleModal(true);
              }}
              customColumnStyle="ButtonView"
              iconWithText={true}
              iconChild={<PlusIcon />}
            />
          </Grid.Column>
        </Grid.Column>
      </Grid>
      {ingredientVisibleModal && recipeId ? (
        <RecipeAddIngredientModal
          visibleModal={ingredientVisibleModal}
          setVisibleModal={setIngredientVisibleModal}
          recipeId={recipeId}
          recipeDataRefetch={recipeDataRefetch}
          usedColors={usedColors}
          calculatedProductSalesUnit={recipeData?.originalRecipe?.calculatedProductSalesUnit || []}
          genericIngredient={recipeData?.originalRecipe?.genericIngredient || []}
          calculatedIngredient={recipeData?.originalRecipe?.calculatedIngredient || []}
        />
      ) : null}
    </>
  );
};

export default RecipeIngredientRegister;
